angular.module('common.services').factory('UnitSystem', [
  'SystemConstants',
  function (SystemConstants) {
    var _map = {
      $v: null,
      $l: null
    }

    var _out = {
      value: function (value, label, format) {
        _map['$v'], (_map['$l'] = null)

        // if just the label process is
        var _process = label || value
        if (typeof _process === 'string' && SystemConstants.data[_process]) {
          _map['$l'] =
            SystemConstants.unit === 0
              ? _process
              : SystemConstants.data[_process][0]
        }

        if (typeof value === 'number' && label && SystemConstants.data[label]) {
          _map['$v'] =
            SystemConstants.unit === 0
              ? SystemConstants.data[label].length > 2
                ? SystemConstants.data[label][1] * value
                : value
              : value *
                SystemConstants.data[label][
                  SystemConstants.data[label].length - 1
                ]
          _map['$v'] = parseFloat(Math.round(_map['$v'] * 100) / 100).toFixed(2)
        }

        if (format) {
          for (var _i in _map) {
            if (format.indexOf(_i) !== -1) {
              if (_i != 0) {
                _map[_i] = ' ' + _map[_i]
              }
              format = format.split(_i).join(_map[_i])
            }
          }
        }
        // console.log( _map["$v"])
        return format || (!label ? _map['$l'] : _map['$v'])
      }
    }

    _out.__defineGetter__('current', function () {
      return SystemConstants.unitLabels[SystemConstants.unit]
    })

    return _out
  }
])
